// eslint-disable-next-line no-debugger
// debugger;

import {
  AnyElement,
  AnyNode,
  noop,
  Cache,
  ReadInBrowserEnum,
  toBlob,
  milliseconds
} from "@zyzgroup/core-common";
import { atomWriteStyle, getStyle, setStyle } from "./useStyle";
import { atomWriteAttribute } from "./useAttribute";
import { useEventListener } from "./useEventListener";
import { getImageData } from "../image";
import { selectFileInBrowser, readFileInBrowser } from "../file";
import { Easing, EasingFunction, rAF } from "../animate";

// document.querySelector(".element");
// document.querySelector("#element");
// document.querySelector("div");
// document.querySelector('[name="username"]');
// document.querySelector("div + p > span");
// document.querySelectorAll("p");
// document.getElementById("id属性值");
// document.getElementsByClassName("class属性值");
// document.getElementsByTagName("标签名");
// document.getElementsByName("name属性值");
// element.querySelector("CSS选择器");
// element.querySelectorAll("CSS选择器");
// document.documentElement; // 获取页面中的HTML标签;
// document.body;

// document.defaultView
// document.parentWindow

// BOM Browser Object Model
// BOM 的顶级对象是 window

// const target = document.documentElement || document || window;

// history
// history.go(3); //向前跳转三个记录
// history.go(-1); //向后跳转一个记录
// history.forward() 向前跳转一个页面
// history.back() 向后跳转一个页面
// history.length 获取历史记录数

// location.reload(true)

// screen

// const myWin = window.open("htttp://www.vue3js.cn", "topFrame");
// myWin.close();

// 按重要性排序
export const domPrefixes = ["", "-webkit-", "-moz-", "-o-", "-ms-"];

export function transform(
  el: AnyElement,
  options: {
    x?: number;
    y?: number;
    z?: number;
  }
) {
  const x = options.x || 0;
  const y = options.y || 0;
  const z = options.z || 0;
  atomWriteStyle(
    el,
    "transform",
    `translate(${x}px, ${y}px) translateZ(${z}px)`
  );
}

export function animate(
  el: AnyElement,
  options: {
    easingFn?: EasingFunction;
    duration?: number;
    delay?: number;
    deltaX: number;
    deltaY: number;
  }
) {
  const easingFn = options?.easingFn || Easing.Linear.None;
  const duration = options?.duration || 0;
  const delay = options?.delay || 0;
  const startTime = milliseconds();
  const destTime = startTime + duration;
  let x = 0;
  let y = 0;
  const deltaX = options.deltaX;
  const deltaY = options.deltaY;
  function step() {
    const now = milliseconds();
    if (now >= destTime) {
      transform(el, { x: deltaX - x, y: deltaY - y });
      return;
    }
    const t = (now - startTime) / duration;
    const easing = easingFn(t);
    const newX = deltaX * easing;
    const newY = deltaY * easing;
    transform(el, { x: newX - x, y: newY - y });
    x = newX;
    y = newY;
    rAF(step);
  }
  setTimeout(() => {
    step();
  }, delay);
}

// http://stackoverflow.com/a/384380/182183
export const isElement =
  typeof HTMLElement === "object"
    ? function isElementDOM2(obj: any) {
        return obj instanceof HTMLElement;
      }
    : function isElementQuirky(obj: any) {
        return (
          obj &&
          typeof obj === "object" &&
          obj.nodeType === 1 &&
          typeof obj.nodeName === "string"
        );
      };

export function createObjectURL(blob: File | Blob | MediaSource) {
  return window.URL.createObjectURL(blob);
}

export function revokeObjectURL(url: string) {
  return window.URL.revokeObjectURL(url);
}

// The DOMContentLoaded event is fired when the document has been completely loaded and parsed,
// without waiting for stylesheets, images, and subframes to finish loading
// the load event can be used to detect a fully-loaded page
export function onDocumentReady(cb: () => void) {
  let isCalled = false;
  function check() {
    // https://developer.mozilla.org/en-US/docs/Web/API/Document/readyState
    // loading interactive complete|loaded
    if (/loaded|complete/.test(document.readyState) && !isCalled) {
      remove();
      cb();
      isCalled = true;
    }
  }
  const remove1 = useEventListener(document, "DOMContentLoaded", check);
  const remove2 = useEventListener(window, "load", check);
  const timer = setInterval(check, 100);
  const remove = () => {
    clearInterval(timer);
    remove1?.();
    remove2?.();
  };
  return remove;
}

export function onBeforeUnload(cb: (e: BeforeUnloadEvent) => void) {
  return useEventListener(window, "beforeunload", (e: BeforeUnloadEvent) => {
    cb(e);
  });
}

export async function useLoadScript(
  url: string,
  ms = 60000
  // onload?: (e: Event) => void,
  // onerror?: (
  //   e: Event | string,
  //   source?: string,
  //   lineno?: number,
  //   colno?: number,
  //   error?: Error
  // ) => void
) {
  return new Promise((resolve, reject) => {
    const script = document.createElement("script");
    script.type = "text/javascript";
    // 默认情况下，动态脚本的行为是 async 的
    script.async = false; // 设置脚本将像 defer 那样
    script.onload = (e) => {
      clearTimeout(timeout);
      // onload?.(e);
      resolve(e);
      // avoid memory leaks in IE
      script.onerror = script.onload = null;
    };
    script.onerror = (e) => {
      clearTimeout(timeout);
      // onerror?.(e);
      reject(e);
    };
    script.src = url;
    const timeout: ReturnType<typeof setTimeout> = setTimeout(() => {
      reject("Timeout!");
    }, ms);
    document.body.appendChild(script);
  });
}

export function useClickA(blobOrUrl: Blob | string, fileName: string) {
  const a = document.createElement("a");
  a.style.visibility = "hidden";
  a.download = fileName;
  if (typeof blobOrUrl === "string") {
    a.href = blobOrUrl;
  } else {
    a.href = window.URL.createObjectURL(blobOrUrl);
  }
  // document.body.appendChild(a);
  a.click();
  // document.body.removeChild(a);
  // window.URL.revokeObjectURL(a.href);
}

// <link rel="stylesheet" href="mystyles.css" media="noexist" onload="this.media='all'">
// <link rel="alternate stylesheet" href="mystyles.css" onload="this.rel='stylesheet'">
export async function useLoadLink(
  url: string,
  parent = document.getElementsByTagName("head")[0],
  ms = 60000
  // onload?: (event: Event) => void,
  // onerror?: (
  //   event: Event | string,
  //   source?: string,
  //   lineno?: number,
  //   colno?: number,
  //   error?: Error
  // ) => void
) {
  return new Promise((resolve, reject) => {
    const link = document.createElement("link");
    // link.type = "text/css";
    link.setAttribute("type", "text/css");
    // link.rel = "stylesheet";
    link.setAttribute("rel", "stylesheet");
    link.onload = (e) => {
      clearTimeout(timeout);
      // onload?.(e);
      resolve(e);
      // avoid memory leaks in IE
      link.onerror = link.onload = null;
    };
    link.onerror = (e) => {
      clearTimeout(timeout);
      // onerror?.(e);
      reject(e);
    };
    // link.href = url;
    link.setAttribute("href", url);
    const timeout: ReturnType<typeof setTimeout> = setTimeout(() => {
      reject("Timeout!");
    }, ms);
    parent.appendChild(link);
  });
}

/// 等待样式全部加载完成
export function waitForStyleSheetsLoaded() {
  return new Promise<void>((resolve) => {
    const links = Array.from(
      document.querySelectorAll("link[rel=stylesheet]")
    ) as HTMLLinkElement[];
    let loadedCount = document.styleSheets.length || 0;
    const check = () => {
      if (loadedCount >= links.length) {
        resolve();
        return true;
      }
      return false;
    };
    if (!check()) {
      links.forEach((stylesheet) => {
        stylesheet.onload = () => {
          loadedCount += 1;
          check();
        };
      });
    }
  });
}

// "https://s3-us-west-2.amazonaws.com/s.cdpn.io/181794/kl-owl.png"
// "https://s3-us-west-2.amazonaws.com/s.cdpn.io/181794/kl-deer.png"
// "https://s3-us-west-2.amazonaws.com/s.cdpn.io/181794/kl-hipster.png"
// "https://s3-us-west-2.amazonaws.com/s.cdpn.io/181794/kl-ram.png"
// "https://s3-us-west-2.amazonaws.com/s.cdpn.io/181794/kl-dog.png"
// "https://s3-us-west-2.amazonaws.com/s.cdpn.io/181794/kl-sideram.png"
// "https://s3-us-west-2.amazonaws.com/s.cdpn.io/181794/kl-multiram.png"
// "https://s3-us-west-2.amazonaws.com/s.cdpn.io/181794/kl-gorilla.png"
// "https://s3-us-west-2.amazonaws.com/s.cdpn.io/181794/kl-bird.png"
export interface RawImageInfo {
  width: number;
  height: number;
  aspectRatio: number;
  element: HTMLImageElement;
  imageData?: ImageData;
}

const caches = new Cache<RawImageInfo>();

/**
 * 动态获取图片信息
 */
export async function useLoadImage(url: string | Blob | File, ms = 60000) {
  return new Promise<RawImageInfo>((resolve, reject) => {
    const finalUrl = typeof url === "string" ? url : createObjectURL(url);
    const cached = caches.get(finalUrl);
    if (cached) {
      return resolve(cached);
    }
    const timeout: ReturnType<typeof setTimeout> = setTimeout(() => {
      reject("Timeout!");
    }, ms);
    // const image = new Image();
    const image = document.createElement("img");
    // 注意跨域 CORS ：only works if the remote server sets : Access-Control-Allow-Origin "*"
    // image.crossOrigin = "Anonymous";
    // image.setAttribute("crossOrigin", "");
    image.onload = () => {
      clearTimeout(timeout);
      // avoid memory leaks in IE
      image.onerror = image.onload = null;
      const width = image.naturalWidth || image.width;
      const height = image.naturalHeight || image.height;
      const rawImageInfo = {
        width,
        height,
        aspectRatio: width / height,
        element: image,
        imageData: getImageData(image)
      };
      caches.set(finalUrl, rawImageInfo);
      resolve(rawImageInfo);
    };
    image.onerror = (e) => {
      clearTimeout(timeout);
      reject(e);
    };
    image.src = finalUrl;

    // document.body.appendChild(image);
  });
}

export async function useSelectFile<T extends string | ArrayBuffer>(
  readType: ReadInBrowserEnum = ReadInBrowserEnum.text,
  accepts: string[] = ["*"]
) {
  const files = await selectFileInBrowser(accepts);
  const file = files[0];
  const data = await readFileInBrowser<T>(file, readType);
  return {
    type: file.type,
    name: file.name,
    size: file.size,
    data
  };
}

export async function useSelectFileImage(accepts: string[] = ["image/*"]) {
  const files = await selectFileInBrowser(accepts);
  const file = files[0];
  if (!file.type.match(/image\/*/)) {
    return new Error("Not Image Type!");
  }
  const ab = await readFileInBrowser<ArrayBuffer>(
    file,
    ReadInBrowserEnum.arraybuffer
  );
  const blob = toBlob(ab);
  const rawImageInfo = await useLoadImage(blob);
  return {
    type: file.type,
    name: file.name,
    size: file.size,
    data: ab,
    width: rawImageInfo.width,
    height: rawImageInfo.height,
    aspectRatio: rawImageInfo.aspectRatio,
    imageData: rawImageInfo.imageData
  };
}

export function getSelectedText(): string {
  return window.getSelection()?.toString() || "";
}

export function setWindowTitle(title: string) {
  document.getElementsByTagName("title")[0].innerText = title;
  document.title = title;
}

export function vibrate(ms = 200) {
  if ("vibrate" in navigator) {
    window.navigator.vibrate(ms);
  } else {
    console.error("Your device is not support vibrate on this browser.");
  }
}

export async function useClipboard(text: string) {
  if (navigator.clipboard) {
    return await navigator.clipboard.writeText(text);
  } else {
    const textArea = document.createElement("textarea");
    textArea.value = text;
    textArea.style.opacity = "0";
    // avoid scrolling to bottom
    textArea.style.position = "fixed";
    textArea.style.top = "0";
    textArea.style.left = "0";
    // document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();
    // document.body.removeChild(textArea);
    return document.execCommand("copy");
  }
}

// window.moveBy(x,y) 从当前位置水平移动窗体x个像素，垂直移动窗体y个像素，x为负数，将向左移动窗体，y为负数，将向上移动窗体
// window.moveTo(x,y) 动窗体左上角到相对于屏幕左上角的(x,y)点
// window.resizeBy(w,h) 相对窗体当前的大小，宽度调整w个像素，高度调整h个像素。如果参数为负值，将缩小窗体，反之扩大窗体
// window.resizeTo(w,h) 把窗体宽度调整为w个像素，高度调整为h个像素
// window.scrollTo(x,y) 如果有滚动条，将横向滚动条移动到相对于窗体宽度为x个像素的位置，将纵向滚动条移动到相对于窗体高度为y个像素的位置
// window.scrollBy(x,y) 如果有滚动条，将横向滚动条向左移动x个像素，将纵向滚动条向下移动y个像素
export function scrollTo(x = 0, y = 0) {
  window.scrollTo(x, y);
}

export function setManualScroll() {
  let remove1 = noop;
  let remove2 = noop;
  if ("scrollRestoration" in window.history) {
    window.history.scrollRestoration = "manual";
    // reset scrollRestoration to auto when leaving page, allowing page reload
    // and back-navigation from other pages to use the browser to restore the
    // scrolling position.
    remove1 = onBeforeUnload(() => {
      window.history.scrollRestoration = "auto";
    });
    // Setting scrollRestoration to manual again when returning to this page.
    remove2 = onDocumentReady(() => {
      window.history.scrollRestoration = "manual";
    });
  }
  return () => {
    remove1();
    remove2();
  };
}

export function isRootEl(el: AnyElement) {
  return /(html|body)/i.test(el.tagName) || el === document.documentElement;
}

export const isActiveEl = (el: AnyElement) => {
  // http://stackoverflow.com/posts/2684561/revisions
  return (
    el === document.activeElement && ((el as any).type || (el as any).href)
  );
};

export function getRemSize(): number {
  return parseFloat(getComputedStyle(document.documentElement).fontSize);
}

export function rem2px(rem: number): number {
  return rem * getRemSize();
}

export function getEmSize(el: AnyElement): number {
  return el.parentElement
    ? parseFloat(getComputedStyle(el.parentElement).fontSize)
    : getRemSize();
}

export const nearestElement = (el: AnyElement) => {
  let elm: AnyElement | ParentNode = el;
  while (elm && elm.nodeType !== 1 /* ELEMENT */) {
    const parent = elm.parentElement || el.parentNode;
    if (!parent) {
      break;
    }
    elm = parent;
  }
  return elm;
};

export const parent = (el: AnyElement) => {
  return el.parentElement;
  // return el.parentNode;
};

export const parents = (
  node: AnyElement | null,
  ps: AnyElement[] = []
): AnyElement[] => {
  if (!node || (node.parentElement === null && node.parentNode === null)) {
    return ps;
  }
  // return parents(node.parentElement || el.parentNode, ps.concat([node]));
  return parents(node.parentElement, ps.concat([node]));
};

export function scrollParent(el: AnyElement) {
  const ps = parents(el);
  for (let i = 0, n = ps.length; i < n; i++) {
    if (
      /(auto|scroll)/.test(
        getStyle(ps[i], "overflow") +
          getStyle(ps[i], "overflow-y") +
          getStyle(ps[i], "overflow-x")
      )
    ) {
      return ps[i];
    }
  }
  return document.scrollingElement || document.documentElement;
}

export const containsChild = (el: AnyElement, child: AnyElement) => {
  if (el.contains) {
    return el != child && el.contains(child);
  } else {
    return !!(el.compareDocumentPosition(child) & 16);
  }
};

export const siblings = (el: AnyElement) => {
  return Array.prototype.slice
    .call(el.parentElement?.children)
    .filter((child) => child !== el);
};

export const nextElementSibling = (el: AnyElement) => {
  return el.nextElementSibling;
};

export const previousElementSibling = (el: AnyElement) => {
  return el.previousElementSibling;
};

export const closest = (el: AnyElement, selector: string) => {
  return el.closest(selector);
};

export const shadowRoot = (el: AnyElement) => {
  return el.shadowRoot;
};

export const isInput = (el: AnyElement) => {
  return el.tagName === "INPUT" || el instanceof HTMLInputElement;
};

export const isSelect = (el: AnyElement) => {
  return el.tagName === "SELECT" || el instanceof HTMLSelectElement;
};

export const isTextArea = (el: AnyElement) => {
  return el.tagName === "TEXTAREA" || el instanceof HTMLTextAreaElement;
};

export const isInputCheckbox = (el: AnyElement) => {
  return isInput(el) && el.getAttribute("type") === "checkbox";
};

export const isInputRadio = (el: AnyElement) => {
  return isInput(el) && el.getAttribute("type") === "radio";
};

export const isInputText = (el: AnyElement) => {
  return isInput(el) && el.getAttribute("type") === "text";
};

export const isInputNumber = (el: AnyElement) => {
  return isInput(el) && el.getAttribute("type") === "number";
};

export function changeSelected(el: AnyElement, selectedValue: string) {
  if (isSelect(el)) {
    const options = (el as HTMLSelectElement).options;
    for (let i = 0, len = options.length; i < len; i++) {
      options[i].selected = options[i].value == selectedValue;
    }
  }
}

export function changeRadioChecked(el: AnyElement, checkedValue: string) {
  if (isInputRadio(el)) {
    const options = document.getElementsByName((el as HTMLInputElement).name);
    for (let i = 0, len = options.length; i < len; i++) {
      const option = options[i] as HTMLInputElement;
      option.checked = option.value == checkedValue;
    }
  }
}

export function changeCheckboxChecked(el: AnyElement, checked: boolean) {
  if (isInputCheckbox(el)) {
    (el as HTMLInputElement).checked = checked;
  }
}

export function insert(
  el: AnyElement,
  html: string | AnyElement,
  method:
    | "append"
    | "appendChild"
    | "prepend"
    | "after"
    | "before"
    | "replaceWith" = "append"
) {
  if (typeof html == "string") {
    el[method](createFragment(html));
  } else {
    el[method](html);
  }
}

export function html(el: AnyElement, html: string | AnyElement) {
  if (typeof html == "string") {
    el.innerHTML = html;
    const newEl = scriptConvert(el);
    if (newEl != el) {
      el = newEl;
    }
  } else {
    insert(html, "replaceWith");
  }
}

export const empty = function (el: AnyElement) {
  html(el, "");
};

export const text = (el: AnyElement, text: string) => {
  el.textContent = text;
};

export const getInnerText = (el: AnyElement) => {
  if (el instanceof SVGElement) {
    return "";
  }
  let copyText = el.innerText;
  if (!copyText) {
    const slots = el.querySelector("slot")?.assignedNodes() || [];
    let index = 0;
    while (!copyText && index <= slots.length - 1) {
      if ("innerText" in slots[index]) {
        copyText = (slots[index] as HTMLElement).innerText;
      }
      index++;
    }
  }
  return copyText;
};

export const remove = (el: AnyElement) => {
  return el.remove();
  // return el.parentElement?.removeChild(el);
};

// 耗时久
export function toggleElDisplay(el: AnyElement, force?: boolean) {
  if (
    (getStyle(el, "display") == "none" && force === undefined) ||
    force === true
  ) {
    showEl(el);
  } else {
    hideEl(el);
  }
}

export function showEl(el: AnyElement) {
  setStyle(
    el,
    "display",
    el instanceof HTMLTableRowElement
      ? "table-row"
      : el instanceof HTMLTableCellElement
      ? "table-cell"
      : "block"
  );
}

export function hideEl(el: AnyElement) {
  setStyle(el, "display", "none");
}

export function toggleClass(
  el: AnyElement,
  className: string,
  act: "toggle" | "add" | "remove" = "toggle"
) {
  const classNames = className.split(/[,\s]+/);
  if (el.classList) {
    classNames.forEach((singleClassName) => {
      const name = singleClassName.trim();
      if (name !== "") {
        el.classList[act](name);
      }
    });
  } else {
    const exists = el.className.split(/ +/);
    let isUpdate = false;
    classNames.forEach((singleClassName) => {
      const name = singleClassName.trim();
      if (name !== "") {
        const index = exists.indexOf(name);
        switch (act) {
          case "add":
            if (index === -1) {
              exists.push(name);
              isUpdate = true;
            }
            break;
          case "remove":
            if (index !== -1) {
              exists.splice(index, 1);
              isUpdate = true;
            }
            break;
          case "toggle":
            if (index === -1) {
              exists.push(name);
            } else {
              exists.splice(index, 1);
            }
            isUpdate = true;
            break;
        }
      }
    });
    if (isUpdate) {
      atomWriteAttribute(
        el,
        "class",
        exists.join(" ").replace(/^\s+/, "").replace(/\s+$/, "")
      );
    }
  }
}

export function addClass(el: AnyElement, className: string) {
  toggleClass(el, className, "add");
}

export function removeClass(el: AnyElement, className: string) {
  toggleClass(el, className, "remove");
}

export function hasClass(el: AnyElement, className: string): boolean {
  return new RegExp("(?:^|\\s+)" + className + "(?:\\s+|$)").test(el.className);
}

// document.createDocumentFragment()
// DocumentFragment 接口表示一个没有父级文件的最小文档对象
// 因为 DocumentFragment 不是真实 DOM 树的一部分，它的变化不会引起 DOM 树的重新渲染的操作（reflow），不会导致性能问题
export function createFragment(
  html: string,
  convert = false // 性能优化
): DocumentFragment {
  const tmpl = document.createElement("template");
  tmpl.innerHTML = html;
  if (convert) {
    tmpl.content.childNodes.forEach((node) => {
      const newNode = scriptConvert(node as AnyElement);
      if (newNode != node) {
        tmpl.content.replaceChild(newNode, node);
      }
    });
  }
  return tmpl.content;
}

export function createElement(tagName: string) {
  return document.createElement.call(document, tagName);
}

export function createElementNS(name: string) {
  return document.createElementNS("http://www.w3.org/1999/xhtml", name);
}

export function createTextNode(data: string) {
  return document.createTextNode.call(document, data);
}

function scriptConvert(el: AnyElement) {
  if (el.tagName == "SCRIPT") {
    el = convert(el as HTMLScriptElement);
  }
  if (el.querySelectorAll) {
    el.querySelectorAll("script").forEach((e) => {
      e.parentNode?.replaceChild(convert(e), e);
    });
  }
  return el;
}

// innerHTML, append, etc. script tags will not be executed unless they are proper script tags
function convert(el: HTMLScriptElement) {
  const script = el.ownerDocument.createElement("script");
  script.text = el.text;
  const attrs = el.attributes;
  for (let i = 0, n = attrs.length; i < n; i++) {
    script.setAttribute(attrs[i].name, attrs[i].value);
  }
  return script;
}

// used for : 单点登录（Single Sign On） SSO
// 在这个iframe所加载的HTML中绑定一个事件监听器，当事件被触发时，把接收到的token数据写入localStorage
// window.addEventListener(
//   "message",
//   function (event) {
//     localStorage.setItem("token", event.data);
//   },
//   false
// );
export function iframePostMessage(
  message: any,
  targetOrigin = "http://test.com/localstorage.html"
) {
  // 动态创建一个不可见的iframe，在iframe中加载一个跨域HTML
  const iframe = document.createElement("iframe");
  iframe.src = targetOrigin;
  document.body.append(iframe);
  setTimeout(function () {
    iframe.contentWindow?.postMessage(message, targetOrigin);
  }, 4000);
  setTimeout(function () {
    iframe.remove();
  }, 6000);
}

// 沙盒
export function runInSandbox(code: string) {
  const proxyWindow: Window = new Proxy<Window>(window, {
    get(target, key, receiver) {
      if (
        typeof key == "string" &&
        ["open", "location", "document"].includes(key)
      ) {
        throw new Error(`禁止访问 key: ${key}`);
      }
      if (key === "window") {
        return proxyWindow;
      }
      return Reflect.get(target, key, receiver);
    },
    set(target, key, value, receiver) {
      return Reflect.set(target, key, value, receiver);
    }
  });
  new Function("window", `with(window) { ${code} }`)(proxyWindow, null);
}
